<template>
  <svg viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 0a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h18zm0 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM7.707 12.293a1 1 0 0 1 .083 1.32l-.083.094-2 2a1 1 0 0 1-1.497-1.32l.083-.094 2-2a1 1 0 0 1 1.414 0zm8.586 0a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414zM5.613 4.21l.094.083L12 10.586l6.293-6.293a1 1 0 0 1 1.497 1.32l-.083.094-7 7a1 1 0 0 1-1.32.083l-.094-.083-7-7a1 1 0 0 1 1.32-1.497z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
